import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@bookips/sds";
const SectionLabel = (param)=>{
    let { title , children  } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "subtitle1",
                className: "text-primary",
                children: title
            }),
            children
        ]
    });
};
export default SectionLabel;
